module.exports = __webpack_public_path__ + "static/media/statue.7965c85f.JPG";